import { createContext } from 'react'

import { createContractDesignerEditorStore } from '../store/createStore'

export const ContractDesignerEditorStoreContext = createContext<
  ReturnType<typeof createContractDesignerEditorStore> | undefined
>(undefined)
